<template>
  <section :class="{ 'bg-white': theme === 'light' }">
    <Container
      class="w-full overflow-x-hidden"
      :class="{ 'my-16 lg:my-24': !title, 'py-16 lg:py-24': title }">
      <h2
        v-if="title"
        class="mb-16 text-5xl leading-tight lg:mb-24 lg:text-8xl"
        :class="{ 'text-white': theme === 'dark', 'text-gray-600': theme === 'light' }">
        {{ title }}
      </h2>
      <div
        v-if="isDesktop"
        class="grid gap-x-6 gap-y-12 md:grid-cols-2 lg:grid-cols-3 lg:gap-y-28">
        <SectionBulletPointsSingle
          v-for="(item, i) in items"
          :key="i"
          :item="item"
          :theme="theme"
          :number="numbered ? i + 1 : undefined" />
      </div>
      <Slider
        v-else
        :theme="theme"
        :mobile-per-view="1.2"
        :mobile-spacing="24">
        <SectionBulletPointsSingle
          v-for="(item, i) in items"
          :key="i"
          :item="item"
          :theme="theme"
          :number="numbered ? i + 1 : undefined"
          class="keen-slider__slide flex-shrink-0" />
      </Slider>
    </Container>
  </section>
</template>

<script lang="ts" setup>
  import { useScreenSize } from '../../composables/use-screen-size'

  const { title = '', theme = 'dark', numbered = false } = defineProps<bulletPointsProps>()

  const { isDesktop } = useScreenSize()

  type bulletPointsProps = {
    title?: string
    theme?: 'dark' | 'light'
    numbered?: boolean
    items: {
      title: string
      copy: string
      icon: string
      color: string
    }[]
  }
</script>
